import React, { useEffect, useState } from "react";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import { getAllverificationCustomers } from "../../../apis/customers";
import CommonSearch from "../commonSearch";
import { Moment } from "moment";
import { getAllEmployee } from "../../../apis/employees";
import Select from "react-select";
import { createNewVerifications } from "../../../apis/verification";
import { successAlert } from "../../../style/scss/utils/Alerts";
import { formatDate } from "../../../environment";

const VerificationList = () => {
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [image, setImage] = useState<File | null>(null);
  const [error, setError] = useState<string>("");

  const [states, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = states;

  type EmployeeResponse = {
    full_name: string;
    geo_location: string;
    Image: string;
    CurrentRole: string;
    email: string;
    phoneNumber1: string;
    Designation: string;
    createdAt: string;
    Status: string;
    id: any;
    address: any;
  };

  type EmployeeData = {
    key: number;
    EmpId: string;
    Name: string;
    Image: string;
    CurrentRole: string;
    Email: string;
    Phone: string;
    Designation: string;
    JoiningDate: string;
    Status: string;
    id: any;
    allData: any;
  };

  const fetchAllEmployees = async () => {
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllverificationCustomers(data);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          EmpId: `${i + 1}`,
          Name: `${item.full_name}`,
          Image: item.Image ? item.Image : "--",
          CurrentRole: item.CurrentRole || "--",
          Email: item.email || "--",
          address: item.address || "--",
          Phone: item.phoneNumber1 || "--",
          Designation: item.Designation || "--",
          JoiningDate: formatDate(item.createdAt) || "--",
          Status: item.Status || "--",
          id: item.id || "--",
          allData: item,
        })
      );
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchAllEmployees();
  }, [states]);

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.EmpId.localeCompare(b.EmpId),
    },
    {
      title: "Date",
      dataIndex: "JoiningDate",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Customer Account Number",
      dataIndex: "customerAccountNumber",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.allData.loanAccountNumber}</p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div
            className="avatar avatar-md"
            data-bs-toggle="modal"
            data-bs-target="#view_details"
          >
            <img
              src={`assets/img/users/${record.Image}`}
              className="img-fluid rounded-circle"
              alt=""
            />
          </div>
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="d-inline-flex">
          <div className="action-icon d-inline-flex"></div>
          <div
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#visits"
            className="btn btn-primary d-flex align-items-center"
            onClick={() => handleVisitClick(record)}
          >
            {"Visit"}
          </div>
        </div>
      ),
    },
    {
      title: "Customer Details",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <Link
          to={`/customer-view?id=${record?.allData.id}`}
          className="btn btn-primary d-flex align-items-center"
        >
          {"Details"}
        </Link>
      ),
    },
  ];

  const [customerId, setCustomerId] = useState();

  const mtIdString = sessionStorage.getItem("info");
  let mtId: { id: string } | null = null;

  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "EmployeeData");
    XLSX.writeFile(workbook, "employee_data.xlsx");
  };

  const [allEmployeesData, setEmployeesData] = useState<EmployeeData[]>([]);

  const getAllEmployees = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
      };
      const response = await getAllEmployee(data);
      const filteredEmployees = response.data.filter(
        (employee: any, i: any) => employee.type === "verfication_person"
      );
      const employeeData = filteredEmployees?.map((item: any, i: number) => ({
        label: item.full_name ? item.full_name : "Not Assigned",
        value: item.id || "Not Assigned",
      }));
      setEmployeesData(employeeData);
    } catch (error) {
      console.error(error, "error");
    }
  };
  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };

  useEffect(() => {
    getAllEmployees();
  }, []);
  const [geoLocation, setGeoLocation] = useState<{
    lat: number;
    lon: number;
  } | null>(null);
  const handleVisitClick = (record: EmployeeData) => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setGeoLocation({ lat: latitude, lon: longitude });
        setCustomerId(record?.id);
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          alert("Please enable location access to proceed.");
        } else {
          alert("Unable to retrieve location. Please try again.");
        }
      }
    );
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const payload = {
      employee_id: selectedOption?.value,
      customer_id: customerId,
      financer_id: mtId?.id,
      status: "unverified",
      geo_location: geoLocation,
    };
    try {
      const response = await createNewVerifications(payload);
      if (response.status === true) {
        successAlert("success", "Verification Created ");
        setSelectedOption(undefined);
        setImage(null);
        setError("");
        setSuccessCreation(true);
      }
    } catch (error) {
    } finally {
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={allEmployeeData}
                    setFilteredData={setFilteredData}
                  />
                </div>
                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={states} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {filteredData && filteredData.length > 0 && (
                <Table
                  dataSource={filteredData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="visits">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add Visitor</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Select Employees</label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={allEmployeesData}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="Select Employees"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default VerificationList;
